export function mapCdrToTicketCallDetails(cdr) {
    return {
        startLabel: formatCdrTimestamp(cdr.start ?? cdr.calldate),
        durationLabel: formatCdrDuration(cdr.duration),
        talkTimeLabel: formatCdrDuration(cdr.billsec),
        status: cdr.disposition?.trim() || '—',
    };
}
import { formatSecondsToHms } from '@/shared/model/qstat-calls.model';
export const AGENT_PANEL_IVR_TRACKS_PAGE_SIZE = 3;
/**
 * Formats CDR timestamps for display.
 * Asterisk/CDR values are often serialized with a `Z` suffix but represent wall-clock
 * times (not UTC). Parse the literal date/time from the string to avoid shifting.
 */
export function formatCdrTimestamp(iso) {
    if (!iso?.trim())
        return '—';
    const trimmed = iso.trim();
    const match = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})/);
    if (match) {
        const [, year, month, day, hour, minute, second] = match;
        return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    }
    const d = new Date(trimmed);
    if (Number.isNaN(d.getTime()))
        return trimmed;
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}`;
}
function formatCdrDuration(seconds) {
    if (seconds == null || !Number.isFinite(seconds) || seconds < 0)
        return '—';
    return formatSecondsToHms(Math.round(seconds));
}
function resolveCdrCallType(cdr) {
    const ctx = (cdr.dcontext ?? '').toLowerCase();
    if (ctx.includes('outgoing') || ctx.includes('outbound'))
        return 'Outgoing';
    if (cdr.lastapp === 'Queue' || ctx.includes('queue') || ctx.includes('incoming'))
        return 'Inbound';
    if (ctx.includes('ivr') || ctx.startsWith('continue'))
        return 'IVR';
    return cdr.dcontext?.trim() || cdr.lastapp?.trim() || 'Call';
}
function resolveQueueFromLastData(cdr) {
    if (cdr.lastapp !== 'Queue')
        return undefined;
    const queue = cdr.lastdata?.split(',')[0]?.trim();
    return queue || undefined;
}
export function mapCdrToIvrTrack(cdr) {
    const callId = cdr.uniqueid?.trim() || cdr.linkedid?.trim() || `${cdr.src ?? ''}-${cdr.start ?? ''}`;
    const startLabel = formatCdrTimestamp(cdr.start);
    const answerLabel = formatCdrTimestamp(cdr.answer);
    const endLabel = formatCdrTimestamp(cdr.end);
    const durationLabel = formatCdrDuration(cdr.duration);
    return {
        id: callId,
        callType: resolveCdrCallType(cdr),
        callId,
        startLabel,
        answerLabel,
        endLabel,
        durationLabel,
        dateLabel: startLabel,
        dcontext: cdr.dcontext,
        queueName: resolveQueueFromLastData(cdr),
    };
}
